import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwRadioField";

/**
 * VuwSelectField (extends VuwRadioField)
 * @options
 * - {Boolean} required
 * - {Array | object} dataOption
 * - {String} unit
 * - {Boolean} customizeSelect
 * - {String} emptyOptionText
 */
vuwer.appendKlass("VuwSelectField", {
	inpType: "select",
	inpClassList: ["inp"],
	emptyOptionText: "選択して下さい",
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwSelectField").parent._initialize.call(this, opt) ) {
			// [バリデーションの上書き]
			// 必須
			this.errorMessages.required = this.errorMessages.required.replace(/^いずれかを/, "");
			
			// [required, disabled の動的な切り替え用]
			this.onChangeState(function(state) {
				if( state.hasOwnProperty("readonly") ) {
					!!this.$self && this.$self.toggleClass("is-readonly", !!state.readonly);
					this.$inp.length && this.$inp.prop("readonly", !!state.readonly);
					delete state.readonly;
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		// DOMツリーに登録される前のことも考慮して、$self.findで取得する
		this.$inp = $self.find( "#" + ["inp", this.idStr].join("_") );
		if(this.$inp.length) {
			this.$inp
			.on("change.setVal", function(e, isTrigger) {
				!isTrigger && $.data(this, "vuwField").setVal(this.value, true);
			});
			
			// **** attachPlugin ****
			if(Klass("Console").device[0] === "pc") {
				// [customizeSelect]
				!!this.customizeSelect && this.initCustomizeSelect();
			}
			
			$.data(this.$inp.get(0), "vuwField", this);
			
			this.clearVal();
		}
		return this;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		if( Array.isArray(this.dataOption) ) {
			u_.isString(value) && ( value = parseInt(value) );
			if( !u_.isNumber(value) || isNaN(value) || this.dataOption.length <= value ) {
				if( this.emptyOptionText && u_.isString(this.emptyOptionText) ) {
					value = "";
				} else {
					value = this.default;
					antiTriggerChange = false;
				}
			}
		} else {
			u_.isNumber(value) && ( value = String(value) );
			if( !u_.isString(value) || !value || !this.dataOption.hasOwnProperty(value) ) {
				if( this.emptyOptionText && u_.isString(this.emptyOptionText) ) {
					value = "";
				} else {
					value = this.default;
					antiTriggerChange = false;
				}
			}
		}
		
		Klass("VuwField").prototype.setVal.call(this, value);
		
		if(this.$inp.length && !antiTriggerChange) {
			this.$inp.val(value).trigger("change", [true]);
		}
		return this;
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var val, clones = Klass("VuwField").prototype._getCopiedInp.apply(this, arguments);
		if(clones.length) {
			val = clones[0].text();
			if(val) {
				Array.isArray(this.dataOption) && ( val = parseInt(val) );
				clones[0].attr("data-value", val).text( this.dataOption[val] );
			}
			
			if( !!this.unit && u_.isString(this.unit) ) {
				clones.push( $("<span/>").addClass("unit").html( $.parseHTML(this.unit) ) );
			}
		}
		return clones;
	},
	
	_renderField: function _renderField() {
		var
			isArr = Array.isArray(this.dataOption),
			arr = isArr ? this.dataOption : Object.keys(this.dataOption),
			$inp = $("<select/>").addClass( this.inpClassList.join(" ") ).attr({
				name: this.paramKey,
				id: ["inp", this.idStr].join("_")
			});
		
		$inp.append.apply( $inp, arr.map(function(k, i) {
			var val = isArr ? String(i) : k;
			return $("<option/>").text(isArr ? k : this.dataOption[k]).val(val);
		}, this) );
		
		// 最後に空のoptgroupを追加
		$inp.append( $("<optgroup/>").attr("label", "") );
		
		if( this.emptyOptionText && u_.isString(this.emptyOptionText) ) {
			$inp.prepend( $("<option/>").val("").html( $.parseHTML(this.emptyOptionText) ) );
		}
		
		if( !this.hasOwnProperty("default") ) {
			this.default = $inp.find("option").eq(0).val();
			Array.isArray(this.dataOption) && ( this.default = parseInt(this.default) );
		}
		
		if( !!this.unit && u_.isString(this.unit) ) {
			$inp = $inp.add( $("<span/>").addClass("unit").html( $.parseHTML(this.unit) ) );
		}
		
		return $("<fieldset/>").addClass("vuw-field field-" + this.inpType).attr({
			"id": ["field", this.idStr].join("_"),
			"data-name": this.paramKey
		}).append( $inp );
	},
	
	// ** customize select plugin **
	initCustomizeSelect: function initCustomizeSelect() {
		if(!this.$inp || !this.$inp.length) {
			return this;
		}
		
		this.$self.addClass("customized-select");
		this.widthSetted = false;
		
		if( !vuwer.get("body") ) {
			vuwer.add("body", {
				selector: function() {
					return $(document.body);
				}
			});
			this.isReady && vuwer.get("body").getReady();
		}
		
		// 選択中のデータの表示用
		this.$view = $("<label/>").addClass("inp-sel").attr({
			"for": this.$inp.attr("id")
		}).insertAfter(this.$inp);
		
		$.data(this.$view.get(0), "vuwField", this);
		
		// [$viewの横幅更新の関数]
		this.updWidth = function() {
			if( !this.widthSetted && this.$optList.is(":visible") ) {
				this.$view.width("");
				this.$optList.width("");
				
				setTimeout( (function() {
					var w, pw;
					if(Klass("Console").browser[0] === "chrome") {
						w = this.$optList.width();
					} else {
						w = this.$optBox.width();
					}
					if( (/block$/).test( this.$self.css("display") ) ) {
						pw = this.$self.width();
						(w > pw) && (w = pw);
					}
					
					w = Math.ceil( Math.ceil(w * 10) / 10 );
					
					// 表示領域の更新
					this.$view.width(w);
					// リスト幅も更新する
					this.$optList.width(w);
				}).bind(this), 0);
				
				this.widthSetted = true;
			}
			return this;
		};
		
		// 開閉処理
		this.$view.on("click", function(e, isTrigger) {
			var vuw = $.data(this, "vuwField");
			if( vuw.$inp.prop("disabled") || vuw.$inp.prop("readonly") ) {
				return true;
			}
			
			vuw.$self.toggleClass("is-open");
			if( vuw.$self.hasClass("is-open") ) {
				vuw.updWidth();
				
				// 開いたら、bodyクリックで閉じる
				setTimeout( $.fn.on.bind(vuwer.get("body").$self, "click.closeSel", function(e) {
					vuw.$view.trigger("click", [true]);
				}), 0);
				
			} else {
				vuwer.get("body").$self.off(".closeSel");
			}
		});
		
		// 選択肢の格納領域
		this.$optList = $("<ul/>").addClass("option-list");
		this.$optBox = $("<div/>").addClass("option-box").append(this.$optList).appendTo(this.$self);
		
		// 表示用の選択肢クリックでセレクトボックスの値を変更
		this.$self.on("click", ".inp-opt", function(e) {
			$.data(e.delegateTarget, "vuw").$inp.val( $(this).data("val") )
			.trigger("change", [false, "customizeSelect"]);
		});
		
		// セレクトボックスのchangeイベントで$viewの表示を更新
		this.$inp.on("change.customizeSelect", function() {
			var
				vuw = $.data(this, "vuwField"),
				$selectedOpt;
			
			vuw.$optList.children(".is-selected").removeClass("is-selected");
			$selectedOpt = vuw.$optList.children(".inp-opt[data-val='" + this.value + "']")
			.addClass("is-selected");
			
			vuw.$view.empty().append(
				$("<span/>").append( $selectedOpt.clone().children() )
			);
		});
		
		// [選択肢の更新関数]
		this.updateOptions = function(cb) {
			this.$view.empty();
			this.$optList.empty();
			this.$inp.children().each( this._createCustomOptions.bind(this, cb) );
			
			this.widthSetted = false;
			return this.updWidth();
		};
		
		this._createCustomOptions = function(cb, i, elm) {
			var tagName, text, $li;
			
			if(elm.disabled) {
				return true;
			}
			
			tagName = elm.tagName.toLowerCase();
			if(tagName === "optgroup") {
				if(elm.label) {
					text = elm.label;
					$li = $("<li/>").addClass("opt-group-header").append(
						$("<span/>").text(text)
					).appendTo(this.$optList);
				}
				
				$(elm).children().each( this._createCustomOptions.bind(this, cb) );
				
			} else
			if(tagName === "option") {
				text = $(elm).text();
				$li = $("<li/>").addClass("inp-opt hover-target").attr({
					"data-val": elm.value
				}).append( $("<span/>").text(text) ).appendTo(this.$optList);
				
				if(elm.selected) {
					this.$view.append( $("<span/>").text(text) );
					$li.addClass("is-selected");
				}
				
				u_.isFunction(cb) && cb.call(elm, $li, elm.value);
			}
		};
		
		return this.updateOptions();
	},
	
	/**
	 * dataOptionに連番の要素をセット（時間入力部品などで使用）
	 * @param {integer} len: 追加する要素数
	 */
	setNumberOptions: function setNumberOptions(len) {
		if( !u_.isInteger(len) ) {
			throw new TypeError("arguments[0] must be Integer.");
		}
		
		this.dataOption = [];
		for(let i = 0; i < len; i++) {
			this.dataOption.push( u_.zeroPadding(i, 2) );
		}
		return this;
	}
}, "VuwRadioField");

